<template>
  <div style="padding-bottom: 250px">
    <template>
      <div v-for="(entregavel, i) in form" :key="i" class="row">
        <input-select
          class="col-12 col-md-4"
          label="Tipo"
          @input="preencherCamposDeTipo(entregavel)"
          :disabled="entregavel.previsto"
          v-model="entregavel.tipo"
          :options="options.tipo"
          ref="tipo"
          required
        >
          <template #prepend>
            <b-button
              v-if="form.length > 1"
              @click="removerLinha(entregavel)"
              class="mr-2"
              variant="flat-danger"
            >
              <i class="fas fa-trash"></i>
            </b-button>
          </template>
        </input-select>
        <input-select
          class="col-12 col-md-3"
          :disabled="entregavel.previsto"
          label="Produto"
          v-model="entregavel.subtipo"
          :options="subtipoCalculado(entregavel.tipo)"
          ref="tipo"
          required
        />
        <input-text
          class="col-12 col-md-1"
          label="Sequencial"
          v-model="entregavel.sequencial"
          ref="sequencial"
          required
        />
        <input-date-time
          class="col-12 col-md-4"
          label="Data emissão"
          v-model="entregavel.dataEmissao"
          ref="mes"
          required
        >
          <template #label>
            <div>
              Data da emissão
              <b-badge v-if="entregavel.id" class="ml-2"
                >Previsão: {{ retornarMes(entregavel.prazo) }}</b-badge
              >
            </div>
          </template>
          <template #append>
            <b-button
              v-if="!entregavel.id"
              @click="adicionarLinha"
              class="ml-2"
              variant="flat-info"
            >
              <i class="fas fa-plus"></i>
            </b-button>
          </template>
        </input-date-time>
        <div v-if="entregavel.id" class="col-12">
          <div class="col-12 mb-2">
            <upload
              id="file_entregavel"
              tituloArquivo="Arrastar Arquivo"
              selecioneArquivo="Selecionar Arquivo"
              type=".*"
              @upload="
                (file, nomeArquivo) => {
                  upload(file, nomeArquivo, entregavel);
                }
              "
            />
          </div>

          <b-table-simple small class="mt-2">
            <b-thead head-variant="dark">
              <b-tr>
                <b-th>Nome Arquivo</b-th>
                <b-th>Versão</b-th>
                <b-th>Ações</b-th>
              </b-tr>
            </b-thead>
            <tbody>
              <b-tr
                v-for="(arquivo, i) in entregavel.arquivos"
                :key="`arquivo_${i}`"
              >
                <b-td>{{ arquivo.nomeArquivoAWS }}</b-td>
                <b-td>{{ arquivo.versao }}</b-td>
                <b-td class="flex row">
                  <b-button @click="download(arquivo.id)" variant="flat-info">
                    <i class="fas fa-cloud-download mr-2"></i>
                    Baixar arquivo
                  </b-button>
                  <b-button @click="remover(arquivo.id)" variant="flat-danger">
                    <i class="fas fa-trash"></i>
                  </b-button>
                </b-td>
              </b-tr>
            </tbody>
          </b-table-simple>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import InputSelect from "@/components/inputs/InputSelect";
import InputText from "@/components/inputs/InputText";
import InputDateTime from "@/components/inputs/InputDateTime";

import { FormMixin } from "@/common/mixins/FormMixin";

import helpers from "@/common/utils/helpers";
import cloneDeep from "lodash/cloneDeep";

import Upload from "@/components/upload/Upload";

export default {
  name: "ModalVD",
  mixins: [FormMixin],
  props: {
    duracao: {
      required: true,
    },
    dataInicio: {
      required: true,
    },
    form: {
      type: Array,
      required: true,
    },
    value: {
      type: Object,
    },
    valores: {
      type: Array,
    },
    ativoParaAtualizar: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    InputSelect,
    InputText,
    Upload,
    InputDateTime,
  },
  data: () => ({
    options: {
      tipo: helpers.TipoEntregaveis,
      subtipo: helpers.SubTipoEntregaveis,
    },
    quantidades: [],
    arquivosTemporarios: [],
  }),
  methods: {
    preencherCamposDeTipo(entregavel) {
      this.mudarTipo(entregavel);
      this.setarSequencial(entregavel);
    },
    mudarTipo: function (entregavel) {
      let subtipos = this.subtipoCalculado(entregavel.tipo);
      if (subtipos.length == 1) {
        entregavel.subtipo = subtipos[0].value;
      }
    },
    setarSequencial: function (entregavel) {
      let qtd = cloneDeep(this.quantidades);
      if (entregavel.subtipo) {
        qtd.find((el2) => el2.subtipo == entregavel.tipo).quantidade++;
        entregavel.sequencial = qtd.find(
          (el2) => el2.subtipo == entregavel.tipo
        ).quantidade;
      }
      let mes = helpers.formatarData(entregavel.dataEmissao, "MM");
      let ano = helpers.formatarData(entregavel.dataEmissao, "YYYY");
      let prazo = this.mesesDepesas.find(
        (el2) => el2.mes == mes && el2.ano == ano
      );

      if (prazo) {
        entregavel.mesRealizado = prazo.value;
      }
    },
    atualizarGrade(arquivoAtualizado) {
      const entreg = this.form.find((e) => e.id != "");

      if (entreg) {
        entreg.arquivos.push({
          //id: arquivoAtualizado.entregavelId,
          //relatorioEtapaId: null,
          versao: arquivoAtualizado.versao,
          conteudoBase64: arquivoAtualizado.conteudoBase64,
          nomeArquivoAWS: arquivoAtualizado.nomeArquivoAWS,
        });
      }
    },
    subtipoCalculado: function (tipo) {
      let _tipo = this.options.tipo.find((el) => el.value == tipo);
      let subtipo = _tipo ? _tipo.subtipo : "";
      return this.options.subtipo.filter((el) => {
        return el.value == subtipo;
      });
    },
    adicionarLinha: function () {
      let element = {
        propostaId: null,
        tipo: null,
        subtipo: null,
        mesRealizado: null,
        sequencial: null,
      };

      this.form.push(element);
    },
    removerLinha: function (linha) {
      this.form.splice(this.form.indexOf(linha), 1);
    },
    retornarMes: function (mes) {
      return this.mesesDepesas.find((el) => el.value == mes).text;
    },
    upload: function (file, nomeArquivo, entregavel) {
      if (nomeArquivo !== null && file !== null) {
        let form = {
          entregavelId: entregavel.id,
          relatorioEtapaId: null,
          versao: entregavel.arquivos.length + 1,
          conteudoBase64: file,
          nomeArquivoAWS: nomeArquivo,
        };

        this.arquivosTemporarios.push(form);
        // No arquivo modal.vue, dentro do método upload
        this.$emit("arquivoSelecionado", form);

        // entregavel.arquivos.push({
        //   versao: form.versao,
        //   conteudoBase64: file,
        //   nomeArquivoAWS: nomeArquivo,
        // });
      }
    },
    download: function (id) {
      this.$emit("downloadArquivo", id);
    },
    remover: function (id) {
      this.$emit("removerArquivo", id);
    },
  },
  computed: {
    mesesDepesas: function () {
      return helpers.criarArrayMes(this.dataInicio, this.duracao);
    },
  },
  watch: {
    valores: {
      handler: function (valores) {
        helpers.getTipoEntregaveis().forEach((element) => {
          let quantidade = valores
            .filter((aux) => aux.tipo == element.value)
            .sort((a, b) => a.sequencial - b.sequencial)
            .slice(-1);

          if (quantidade.length == 0) {
            this.quantidades.push({
              subtipo: element.value,
              quantidade: 0,
            });
          } else {
            this.quantidades.push({
              subtipo: element.value,
              quantidade: quantidade[0].sequencial,
            });
          }
        });
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
<style lang=""></style>
